import React from 'react';

export default ({ color = '#525979', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 7.5V9H12V10H10.5V11.5H9.5V10H8V9H9.5V7.5H10.5ZM10.5041 1.5C10.778 1.5 11 1.72248 11 1.9967V6.5H10V2.5H2V9.4995L7 4.5L8.5 6V7.4145L7 5.9142L3.4135 9.5H7V10.5H1.4959C1.22203 10.5 1 10.2775 1 10.0033V1.9967C1 1.72238 1.22766 1.5 1.4959 1.5H10.5041ZM4 3.5C4.55228 3.5 5 3.94772 5 4.5C5 5.0523 4.55228 5.5 4 5.5C3.44772 5.5 3 5.0523 3 4.5C3 3.94772 3.44772 3.5 4 3.5Z"
      fill={color}
    />
  </svg>
);
